import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 420,
  parentId: 400,
  name: "Products",
  label: "Products",
  path: "products",
  element: Element,
  user: true,
  admin: false,
  hidden: false,
};

export default route;
